import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

import { INFO_BLOCK_TYPES } from 'constants/components';
import { InfoTransparentIcon } from 'assets/icons';

const styles = {
  block: ({ palette }, type) => ({
    backgroundColor: palette[type]?.main,
    borderRadius: '20px',
    padding: 2,
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  }),
  icon: ({ palette }, type) => ({
    color: palette[type]?.main,
    flex: 'none',
  }),
};

const InfoBlock = ({ text = '', type = INFO_BLOCK_TYPES.INFO, CustomContent = null }) => {
  return (
    <Box sx={(theme) => styles.block(theme, type)}>
      <Box component={InfoTransparentIcon} sx={(theme) => styles.icon(theme, type)} />

      {CustomContent && <CustomContent />}

      {text && (
        <Typography variant="body1" color="text.secondary">
          {text}
        </Typography>
      )}
    </Box>
  );
};

InfoBlock.propTypes = {
  text: PropTypes.string,
  type: PropTypes.oneOf(Object.values(INFO_BLOCK_TYPES)),
  CustomContent: PropTypes.node,
};
export default InfoBlock;
